import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, onMounted, watch } from 'vue';
import request from '@/utils/request'
import { message } from 'ant-design-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DirectorSearchCpa',
  props: {
  modelValue: {
    type: [String, Array],
  },
  name: {
    type: String,
  },
  isStrict: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  mode: {
    type: String,
    default: '',
  },
},
  emits: ['update:modelValue', 'changeValues'],
  setup(__props, { emit: __emit }) {

let _searchDebounce: any = null

const suggestionData: any = ref([])

const props = __props
const emits = __emit
onMounted(() => {
  search('')
})
const value: any = computed({
  set(val) {
    emits('update:modelValue', val)
  },
  get() {
    return props.modelValue
  },
})

watch(props, (newVal) => {
  console.log(123123123, newVal.modelValue);
  
  if (newVal.modelValue) {

    if (!suggestionData.value.length || !suggestionData.value.find(v=>v.value==newVal.modelValue)) {
      request.get(`/api/users/directors`, {
        username: newVal.name,
      }).then((rsp:any) => {
        suggestionData.value = []
        for (let v of rsp.data.list) {
          suggestionData.value.push({
            label: v.username,
            value: v.id
          })
        }
      })
    }
  }
})

const search = (name) => {
  clearTimeout(_searchDebounce)
  _searchDebounce =  setTimeout(() => {
      request.get(`/api/users/directors`, {
        username: name,
      }).then((rsp:any) => {
        suggestionData.value = []
        for (let v of rsp.data.list) {
          suggestionData.value.push({
            label: v.username,
            value: v.id
          })
        }
      })
    }, 600)
  
}

const onChange = (item, options) => {
  console.log(item, options);
  if (item) {
    // emits('changeValues', {director_name: options.label})
    emits('update:modelValue', item)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: value.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    "show-search": "",
    style: {"width":"100%"},
    "default-active-first-option": false,
    "show-arrow": false,
    allowClear: true,
    "filter-option": false,
    "not-found-content": null,
    options: suggestionData.value,
    onSearch: search,
    mode: __props.mode,
    onChange: onChange,
    disabled: __props.disabled
  }, null, 8, ["value", "options", "mode", "disabled"]))
}
}

})